<template>
  <div class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.reservation}}</h1>
        <ReservationList
          :locale="locale"
          :list="list"
          :init="setInit"
          @checked="onChecked" />
        <Pagination
          :option="pagingOption"
          @onPagingClick="onPagingClick" />
      </div>
      <div class="innerSide"><div class="sideBox">
      </div></div>
    </section>
    <div id="setContent">
      <SetReservation
        :locale="locale"
        :checked="checkedList"
        :list="reservationList"
        @uncheckedAll="onUncheckedAll"
        @delReservation="delReservation" />
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ReservationList from '@/components/Reservation/List'
import SetReservation from '@/components/Reservation/SettingList'
import Pagination from '@/components/Pagination/Pagination'

export default {
  name: 'Reservation',
  components: {
    ReservationList,
    SetReservation,
    Pagination
  },
  props: [
    'locale',
    'paging'
  ],
  computed: {
    list () {
      const sort = this.sortBy
      const list = this.reservationList.map(x => x).sort(function (a, b) {
        return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
      })
      const itemCount = this.pagingData.itemCount
      const start = (this.paging - 1) * itemCount
      return list.slice(start, start + itemCount)
    },
    pagingOption () {
      return {
        limit: parseInt(this.reservationList.length / this.pagingData.itemCount) + 1,
        force: Number(this.paging)
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    if (this.$store.state.authentication.userInfo !== null) {
      this.track()
    }
  },
  data () {
    return {
      setInit: false,
      checkedList: [],
      sortBy: 'updateat',
      reservationList: [],
      pagingData: {
        itemCount: 10 // 페이지당 노출할 리스트 아이템
      }
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.userInfo.siteid
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'reservation'
      })
    },
    init () {
      this.checkedList = []
      this.$store.commit('onLoading', true)
      this.$store.dispatch('reservation/getReservation').then((res) => {
        if (res) {
          this.reservationList = res.map(x => {
            return {
              id: x.property,
              title: x.payload.space,
              updateat: x.updateat
            }
          })
        }
        this.$store.commit('onLoading', false)
      })
    },
    onChecked (ids) {
      this.checkedList = ids
      this.setInit = false
    },
    onPagingClick (current) {
      this.$router.replace({ name: 'reservationList', params: { paging: current } })
    },
    onUncheckedAll () {
      this.setInit = true
    },
    delReservation () {
      const ids = this.checkedList
      this.$store.commit('onLoading', true)
      this.$store.dispatch('reservation/delReservation', ids).then((res) => {
        if (res) {
          alert(this.locale.complete_delete)
        } else {
          alert(this.locale.unknown_error)
        }
        this.$store.commit('onLoading', false)
        this.init()
      })
    }
  }
}
</script>
